import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import StateWrappedAttachments from 'components/attachments/components/StateWrappedAttachments';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function StateWrappedAttachmentsApp({
  contextProps,
  wrappedProps,
}) {
  return (
    <AppWrapper {...contextProps}>
      <QueryClientProvider client={queryClient}>
        <StateWrappedAttachments {...wrappedProps} />
      </QueryClientProvider>
    </AppWrapper>
  );
}

StateWrappedAttachmentsApp.propTypes = {
  wrappedProps: PropTypes.shape({
    addImagesButtonPortalId: PropTypes.string,
    attachableId: PropTypes.number,
    attachablePlural: PropTypes.string,
    attachableType: PropTypes.string,
    attachmentIdsField: PropTypes.string,
    attachmentsAttributesField: PropTypes.string,
    seedAttachments: PropTypes.shape({
      data: PropTypes.arrayOf(resourceShape('attachment')).isRequired,
      included: PropTypes.array,
    }).isRequired,
  }).isRequired,
};
